import { render } from "./ClinicInfoTab.vue?vue&type=template&id=73464266"
import script from "./ClinicInfoTab.vue?vue&type=script&lang=js"
export * from "./ClinicInfoTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__